import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { openExternal } from "@/app/platform/browser";
import type { MinimumVersion } from "@shared/contracts";

/**
 * THE WALL, and it is deliberately a wall.
 *
 * Below the service's floor there is no useful screen to show: the shapes this build knows
 * how to parse are gone. A dismissible nudge here would produce bug reports about screens
 * that cannot work, from users who cannot say which version they are on.
 */
export function UpdateGate({ info }: { info?: MinimumVersion }) {
  const { t } = useTranslation();

  return (
    <div className="pt-safe pb-safe flex min-h-dvh flex-col items-center justify-center gap-4 px-8 text-center">
      <h1 className="text-title">{t("update.requiredTitle")}</h1>
      <p className="text-row text-muted-foreground">{t("update.requiredBody")}</p>
      {info && (
        <Button onClick={() => void openExternal(info.storeUrl.ios)}>{t("update.openStore")}</Button>
      )}
    </div>
  );
}
